import React from "react";

export default function CashSkeleton() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {/* Value */}
      <div className="space-y-7 text-sm">
        <div className="flex items-baseline gap-2">
          <span className="w-12 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          <span className="w-24 h-6 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
        </div>
      </div>

      {/* IN/OUT */}
      <div className="space-y-2 text-sm">
        <div className="flex items-baseline gap-3">
          <span className="w-12 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          <span className="w-24 h-6 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
        </div>
      </div>

      {/* IN + Income */}
      <div className="grid grid-col-2 text-sm whitespace-nowrap">
        <div className="space-y-3 w-fit">
          <div className="flex justify-between items-end gap-8">
            <span className="w-10 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="w-24 h-6 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
          <div className="flex justify-between items-end gap-8">
            <span className="w-16 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="w-24 h-6 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
        </div>
      </div>

      {/* OUT + Expense */}
      <div className="grid grid-col-2 text-sm whitespace-nowrap">
        <div className="space-y-3 w-fit">
          <div className="flex justify-between items-end gap-8">
            <span className="w-10 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="w-24 h-6 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
          <div className="flex justify-between items-end">
            <span className="w-16 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
            <span className="w-24 h-6 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></span>
          </div>
        </div>
      </div>
    </div>
  );
}
